var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from './useAppDispatch';
import { fetchIntervalProgress, fetchIntervalProgressIfNeeded, } from '../actions/IntervalProgressActions';
import { isEmptyObject } from '../utils/records';
import { isSameUTCDay } from '../utils/dateAndTime';
import { loggedSelector, registrationNotCompletedSelector } from '../selectors';
import { SECOND_MS } from '../time';
var useCurrentDailyBoostReward = function () {
    var dispatch = useAppDispatch();
    var isLoggedIn = useSelector(loggedSelector);
    var isRegistrationNotCompleted = useSelector(registrationNotCompletedSelector);
    useEffect(function () {
        if (isLoggedIn && !isRegistrationNotCompleted) {
            dispatch(fetchIntervalProgressIfNeeded());
        }
    }, [dispatch, isLoggedIn, isRegistrationNotCompleted]);
    var progress = useSelector(function (state) { return state.intervalProgress; }).progress;
    useEffect(function () {
        var lastTimeout;
        var scheduleNext = function (_a) {
            var _b = _a === void 0 ? { skipFetch: false } : _a, skipFetch = _b.skipFetch;
            if (!skipFetch) {
                dispatch(fetchIntervalProgress());
            }
            lastTimeout = setTimeout(function () {
                scheduleNext();
            }, new Date().setHours(24, 0, 0, 0) - Date.now() + 10 * SECOND_MS);
        };
        scheduleNext({ skipFetch: true });
        return function () {
            if (lastTimeout !== undefined) {
                clearTimeout(lastTimeout);
            }
        };
    }, [dispatch]);
    return useMemo(function () {
        if (isEmptyObject(progress) || !isLoggedIn || isRegistrationNotCompleted) {
            return undefined;
        }
        var isTodayClaimed = progress.lastClaimAt &&
            isSameUTCDay(new Date(), new Date(progress.lastClaimAt));
        if (isTodayClaimed) {
            return undefined;
        }
        return (progress === null || progress === void 0 ? void 0 : progress.nextReward)
            ? __assign(__assign({}, progress === null || progress === void 0 ? void 0 : progress.nextReward), { progressId: progress._id, day: progress.currentProgress + 1 }) : undefined;
    }, [isLoggedIn, isRegistrationNotCompleted, progress]);
};
export default useCurrentDailyBoostReward;
